import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = OpalApiRequestParams<'UpdateBoardColumnV3'>
type RequestBody = OpalApiRequestBody<'UpdateBoardColumnV3'>
type Response = OpalApiResponseDocument<'UpdateBoardColumnV3', 200>

export function updateBoardColumn({
  params,
  requestBody,
}: {
  params: Params
  requestBody: RequestBody
}): Promise<Response> {
  const url = new URL(
    `/boards/v3/${params.path.board_id}/board_columns/${params.path.board_column_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
